"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AllIssuers = void 0;
var AllIssuers;
(function (AllIssuers) {
    AllIssuers["AAA_AKRON"] = "akron_auto_club";
    AllIssuers["AAA_ALABAMA"] = "aaa_alabama";
    AllIssuers["AAA_ARIZONA"] = "aaa_arizona";
    AllIssuers["AAA_BLUEFIELD"] = "aaa_allied_group_bluefield_region";
    AllIssuers["AAA_BLUEGRASS"] = "aaa_allied_group_bluegrass_region";
    AllIssuers["AAA_CAROLINAS"] = "aaa_carolinas";
    AllIssuers["AAA_CENTRAL_PENN"] = "aaa_central_penn";
    AllIssuers["AAA_CHICAGO"] = "auto_club_group_chicago";
    AllIssuers["AAA_CINCINNATI"] = "aaa_allied_group_cincinnati_tristate_region";
    AllIssuers["AAA_COLORADO"] = "aaa_colorado";
    AllIssuers["AAA_EAST_CENTRAL"] = "aaa_east_central";
    AllIssuers["AAA_EAST_PENN"] = "aaa_east_central_east_penn_region";
    AllIssuers["AAA_FINDLAY"] = "findlay_automobile_club";
    AllIssuers["AAA_FLORIDA"] = "auto_club_group_florida";
    AllIssuers["AAA_HARTFORD"] = "aaa_allied_group_greater_hartford_region";
    AllIssuers["AAA_HAWAII"] = "aaa_hawaii";
    AllIssuers["AAA_HOOSIER"] = "hoosier_motor_club";
    AllIssuers["AAA_HUDSON_VALLEY"] = "aaa_hudson_valley";
    AllIssuers["AAA_KANSAS"] = "aaa_allied_group_kansas_region";
    AllIssuers["AAA_KENTUCKY"] = "aaa_east_central_kentucky_region";
    AllIssuers["AAA_MERRIMACK_VALLEY"] = "aaa_merrimack_valley";
    AllIssuers["AAA_MIAMI_OH"] = "aaa_allied_group_miami_county_oh_region";
    AllIssuers["AAA_MIAMI_VALLEY"] = "aaa_allied_group_miami_valley_region";
    AllIssuers["AAA_MICHIGAN"] = "auto_club_group_michigan";
    AllIssuers["AAA_MID_ATLANTIC"] = "aaa_mid-atlantic";
    AllIssuers["AAA_MINNEAPOLIS"] = "auto_club_group_minneapolis";
    AllIssuers["AAA_MINNESOTA"] = "auto_club_group_minnesota";
    AllIssuers["AAA_MISSOURI"] = "aaa_missouri";
    AllIssuers["AAA_MOUNTAINWEST"] = "aaa_mountainwest";
    AllIssuers["AAA_NEBRASKA"] = "auto_club_group_nebraska";
    AllIssuers["AAA_NEW_MEXICO"] = "aaa_new_mexico";
    AllIssuers["AAA_NORCAL_NEVADA_UTAH"] = "aaa_northern_california_nevada_utah";
    AllIssuers["AAA_NORTH_DAKOTA"] = "auto_club_group_north_dakota";
    AllIssuers["AAA_NORTH_PENN"] = "aaa_north_penn";
    AllIssuers["AAA_NORTHEAST"] = "aaa_northeast";
    AllIssuers["AAA_NORTHERN_NEW_ENGLAND"] = "aaa_northern_new_england";
    AllIssuers["AAA_NORTHHAMPTON"] = "aaa_northampton_county";
    AllIssuers["AAA_NORTHWAY"] = "aaa_northway";
    AllIssuers["AAA_OHIO"] = "ohio_auto_club";
    AllIssuers["AAA_OHIO_NW"] = "aaa_allied_group_northwest_ohio_region";
    AllIssuers["AAA_OKLAHOMA"] = "aaa_oklahoma";
    AllIssuers["AAA_OREGON_IDAHO"] = "aaa_oregon/idaho";
    AllIssuers["AAA_PIONEER_VALLEY"] = "aaa_pioneer_valley";
    AllIssuers["AAA_READING_BERKS"] = "aaa_reading-berks";
    AllIssuers["AAA_SCHUYLKILL"] = "aaa_schuylkill_county";
    AllIssuers["AAA_SHELBY"] = "aaa_shelby_county";
    AllIssuers["AAA_SOCAL"] = "automobile_club_of_southern_california";
    AllIssuers["AAA_SOUTH_DAKOTA"] = "aaa_south_dakota";
    AllIssuers["AAA_SOUTH_JERSEY"] = "aaa_south_jersey";
    AllIssuers["AAA_SOUTH_WV"] = "aaa_allied_group_southern_west_virginia";
    AllIssuers["AAA_SOUTHERN_PENN"] = "aaa_southern_pennsylvania";
    AllIssuers["AAA_TEXAS"] = "aaa_texas";
    AllIssuers["AAA_TIDEWATER"] = "aaa_tidewater_virginia";
    AllIssuers["AAA_TN"] = "auto_club_group_tennessee";
    AllIssuers["AAA_WASHINGTON"] = "aaa_washington";
    AllIssuers["AAA_WESTERN_CENTRAL_NY"] = "aaa_western_and_central_new_york";
    AllIssuers["AAA_WISCONSIN"] = "auto_club_group_wisconsin";
    AllIssuers["ACCEPTANCE"] = "acceptance";
    AllIssuers["ACUITY"] = "acuity";
    AllIssuers["AFB"] = "afb";
    AllIssuers["AG_WORKERS"] = "ag_workers";
    AllIssuers["AI_UNITED"] = "ai_united";
    AllIssuers["ALFA"] = "alfa";
    AllIssuers["ALINSCO"] = "alinsco";
    AllIssuers["ALLIANCE"] = "alliance";
    AllIssuers["ALLSTATE"] = "allstate";
    AllIssuers["ALPHA_PROPERTY"] = "alphaproperty";
    AllIssuers["AMAX"] = "amax";
    AllIssuers["AMCO"] = "amco";
    AllIssuers["AMERICAN_ACCESS"] = "american_access_casualty_company";
    AllIssuers["AMERICAN_AUTO"] = "americanauto";
    AllIssuers["AMERICAN_FAMILY"] = "americanfamily";
    AllIssuers["AMERICAN_FREEDOM"] = "americanfreedom";
    AllIssuers["AMERICAN_STRATEGIC"] = "americanstrategic";
    AllIssuers["AMICA"] = "amica";
    AllIssuers["AMIGO"] = "amigo";
    AllIssuers["ANCHOR"] = "anchor";
    AllIssuers["APPARENT"] = "apparent";
    AllIssuers["ARBELLA"] = "arbella";
    AllIssuers["ARROWHEAD"] = "arrowhead";
    AllIssuers["ASI_PROGRESSIVE"] = "asiprogressive";
    AllIssuers["ASPIRE"] = "aspire";
    AllIssuers["ASSURANCE_AMERICA"] = "assuranceamerica";
    AllIssuers["ASSURANT"] = "assurant";
    AllIssuers["AUTO_OWNERS"] = "autoowners";
    AllIssuers["BEAR_RIVER"] = "bearriver";
    AllIssuers["BLUEFIRE"] = "bluefire";
    AllIssuers["BRANCH"] = "branch";
    AllIssuers["BRISTOLWEST"] = "bristolwestinsurance";
    AllIssuers["BUCKLE"] = "buckle";
    AllIssuers["CABRILLO"] = "cabrillo";
    AllIssuers["CAL_AUTO"] = "caautomobile";
    AllIssuers["CALCAS"] = "calcas";
    AllIssuers["CAPITAL"] = "capital_insurance_group";
    AllIssuers["CEM"] = "cem";
    AllIssuers["CERTAINLY"] = "certainly";
    AllIssuers["CHUBB"] = "chubb";
    AllIssuers["CITIZENS_INSURANCE"] = "citizensinsurance";
    AllIssuers["CLEARCOVER"] = "clearcover";
    AllIssuers["COAST_NATIONAL"] = "coastnational";
    AllIssuers["COLONIAL"] = "colonialcounty";
    AllIssuers["COMMONWEALTH"] = "commonwealth";
    AllIssuers["CONNECT"] = "connect";
    AllIssuers["COUNTRY_FINANCIAL"] = "countryfinancial";
    AllIssuers["COVER"] = "cover";
    AllIssuers["COWBOY"] = "cowboy";
    AllIssuers["CURE"] = "cure";
    AllIssuers["DAIRYLAND"] = "dairyland";
    AllIssuers["DASHER"] = "dasher";
    AllIssuers["DEMO"] = "demo";
    AllIssuers["DIRECT_AUTO"] = "directauto";
    AllIssuers["DUMMY"] = "dummy";
    AllIssuers["ELEPHANT"] = "elephant";
    AllIssuers["ENCOMPASS"] = "encompass";
    AllIssuers["EQUITY_INSURANCE"] = "equityinsurance";
    AllIssuers["ERIE"] = "erie";
    AllIssuers["ESTRELLA"] = "estrella";
    AllIssuers["ESURANCE"] = "esurance";
    AllIssuers["FALCON"] = "falcon";
    AllIssuers["FALLSLAKE"] = "fallslake";
    AllIssuers["FARM_BUREAU"] = "farmbureau";
    AllIssuers["FARMERS"] = "farmers";
    AllIssuers["FIRST_CHICAGO"] = "firstchicago";
    AllIssuers["FOREMOST"] = "foremost";
    AllIssuers["FOUNDERS"] = "founders";
    AllIssuers["FRED_LOYA"] = "fredloya";
    AllIssuers["FREEWAY"] = "freewayinsurance";
    AllIssuers["GAINSCO"] = "gainsco";
    AllIssuers["GARRISON"] = "garrison";
    AllIssuers["GEICO"] = "geico";
    AllIssuers["GERMANIA"] = "germania";
    AllIssuers["GERMANTOWN"] = "gmic";
    AllIssuers["GLACIER"] = "glacier";
    AllIssuers["GO_INSURANCE"] = "goinsurance";
    AllIssuers["GOAUTO"] = "goauto";
    AllIssuers["GOOD2GO"] = "good2go";
    AllIssuers["GRANGE"] = "grange";
    AllIssuers["GREAT_TEXAS"] = "greattexascounty";
    AllIssuers["GRINNEL"] = "grinnel";
    AllIssuers["HALLMARK_INSURANCE"] = "hallmarkinsurance";
    AllIssuers["HANOVER"] = "hanover";
    AllIssuers["HARBOR"] = "harbor";
    AllIssuers["HASTINGS"] = "hastings";
    AllIssuers["HIROAD"] = "hiroad";
    AllIssuers["HOME_STATE"] = "homestatecounty";
    AllIssuers["HOMEOWNERS_OF_AMERICA"] = "homeownersofamerica";
    AllIssuers["HOMESITE"] = "homesite";
    AllIssuers["HORACE_MANN"] = "horacemann";
    AllIssuers["HUGO"] = "hugo";
    AllIssuers["HYRECAR"] = "hyrecar";
    AllIssuers["INFINITY"] = "infinity";
    AllIssuers["INSURE_ON_THE_SPOT"] = "insureonthespot";
    AllIssuers["INTEGON"] = "integon";
    AllIssuers["INTEGRITY"] = "integritypc";
    AllIssuers["JUPITER"] = "jupiter";
    AllIssuers["JUST"] = "just";
    AllIssuers["KEMPER"] = "kemper";
    AllIssuers["KENTUCKY_FARM_BUREAU"] = "kentuckyfarmbureau";
    AllIssuers["KEY"] = "key";
    AllIssuers["KNIGHTBROOK"] = "knightbrook";
    AllIssuers["LEMONADE"] = "lemonade";
    AllIssuers["LIBERTY_MUTUAL"] = "libertymutual";
    AllIssuers["LOOP"] = "loop";
    AllIssuers["MAPFRE"] = "mapfre";
    AllIssuers["MEEMIC"] = "meemic";
    AllIssuers["MENDOTA"] = "mendota";
    AllIssuers["MERCURY"] = "mercury";
    AllIssuers["MET_LIFE"] = "metlife";
    AllIssuers["METRO_MILE"] = "metromile";
    AllIssuers["METROPOLITAN"] = "metropolitangroup";
    AllIssuers["MGA_INSURANCE"] = "mgainsurance";
    AllIssuers["MID_CENTURY"] = "midcenturyinsurance";
    AllIssuers["MILE_AUTO"] = "mileauto";
    AllIssuers["MOTION"] = "motion";
    AllIssuers["NARRAGANSETT_BAY"] = "narragansettbay";
    AllIssuers["NATIONAL_GENERAL"] = "national";
    AllIssuers["NATIONWIDE"] = "nationwide";
    AllIssuers["NJM"] = "njm";
    AllIssuers["NKBC"] = "nkbc";
    AllIssuers["NOBLR"] = "noblr";
    AllIssuers["NORTHBROOK"] = "northbrook";
    AllIssuers["NYCM"] = "nycm";
    AllIssuers["OCEAN_HARBOR_CASUALTY"] = "oceanharborcasualty";
    AllIssuers["OHIO_MUTUAL"] = "ohiomutual";
    AllIssuers["OLD_AMERICAN"] = "oldamericancounty";
    AllIssuers["ONSTAR"] = "onstar";
    AllIssuers["OTHER"] = "other";
    AllIssuers["PALISADES"] = "palisades";
    AllIssuers["PEARL_HOLDING_GROUP"] = "pearlholdinggroup";
    AllIssuers["PEMCO"] = "pemco";
    AllIssuers["PENN"] = "penn";
    AllIssuers["PIONEER"] = "psmic";
    AllIssuers["PLYMOUTH_ROCK"] = "plymouthrock";
    AllIssuers["PROGRESSIVE"] = "progressive";
    AllIssuers["PRONTO"] = "pronto";
    AllIssuers["PURE"] = "pure";
    AllIssuers["REDPOINT"] = "redpoint";
    AllIssuers["ROCKFORD"] = "rockford";
    AllIssuers["ROOT"] = "root";
    AllIssuers["SAFEAUTO"] = "safeauto";
    AllIssuers["SAFECO"] = "safeco";
    AllIssuers["SAFETY"] = "safetyinsurance";
    AllIssuers["SAFEWAY"] = "safeway";
    AllIssuers["SAGESURE"] = "sagesureins";
    AllIssuers["SAY"] = "say";
    AllIssuers["SEA_HARBOR"] = "seaharbor";
    AllIssuers["SECURITY_FIRST"] = "securityfirst";
    AllIssuers["SELECTIVE"] = "selective";
    AllIssuers["SENTRY"] = "sentry";
    AllIssuers["SHELTER"] = "shelter";
    AllIssuers["SNAP"] = "snap";
    AllIssuers["STATE_AUTO"] = "stateauto";
    AllIssuers["STATE_FARM"] = "statefarm";
    AllIssuers["STILLWATER"] = "stillwater";
    AllIssuers["SUN_COAST"] = "suncoast";
    AllIssuers["TESLA"] = "tesla";
    AllIssuers["TEXAS_COUNTY_MUTUAL"] = "texascountymutual";
    AllIssuers["TEXAS_FARM"] = "txfb";
    AllIssuers["THE_GENERAL"] = "thegeneral";
    AllIssuers["THE_HARTFORD"] = "thehartford";
    AllIssuers["TOGGLE"] = "toggle";
    AllIssuers["TRADERS"] = "traders";
    AllIssuers["TRAVELERS"] = "travelers";
    AllIssuers["TREXIS"] = "trexis";
    AllIssuers["TSC_DIRECT"] = "tscd";
    AllIssuers["TWENTY_ONE_CENTURY"] = "21stcentury";
    AllIssuers["UAIC"] = "uaic";
    AllIssuers["UNIQUE"] = "unique";
    AllIssuers["UNITED_SECURITY"] = "unitedsecurity";
    AllIssuers["UNITRIN"] = "unitrin";
    AllIssuers["UNIVERSAL_PROPERTY"] = "universalproperty";
    AllIssuers["USAA"] = "usaa";
    AllIssuers["VELOX"] = "velox";
    AllIssuers["VERTI"] = "verti";
    AllIssuers["VIKING"] = "viking";
    AllIssuers["WADENA"] = "wadena";
    AllIssuers["WAWANESA"] = "wawanesa";
    AllIssuers["WEST_BEND"] = "westbendinsurance";
    AllIssuers["WESTFIELD"] = "westfield";
    AllIssuers["WISCONSIN"] = "wisconsinmutual";
    AllIssuers["WORKMENS"] = "workmens";
})(AllIssuers = exports.AllIssuers || (exports.AllIssuers = {}));
